<div class="list-card card-shadow py-4 px-5 background-white100 color-secondary position-relative">
  <div *ngIf="label !== ''" [class]="'d-flex position-absolute label-sign ' + color">
    <svg-icon key="fire" *ngIf="isTrending" class="mx-1 my-1"></svg-icon>
    <span *ngIf="!isTrending" class="text-tiny-bold color-secondary mx-1">{{ label }}</span>
  </div>
  <ng-content></ng-content>
</div>
